<template lang="pug">
div.small-margin
  //- pre {{tempText}}
  //- pre {{initBlock}}
  b-field(grouped)
    b-field(:label="initBlock.config.label" label-position="on-border" :maxlength="initBlock.config.maxlength" :type="(tempText !== initBlock.value.text && tempText !== null) ? 'is-danger' : undefined" :message="(tempText !== initBlock.value.text && tempText !== null) ? 'Achtung! Ändern der URL hat SEO Auswirkungen.' : ''")
      b-input(:value="tempText" @input="saveTempText")
    b-button(v-if="tempText !== initBlock.value.text" @click="syncNavigationService") Speichern
</template>

<script>
import * as slugify from 'slugify';

export default {
  components: {

  },
  props: {
    parentKey: String,
    initBlock: {
      type: Object,
      default() {
        return {
          value: {
            text: ""
          },
          config: {
            path: ""
          }
        }
      }
    }
  },
  data() {
    return {
      tempText: "",
    };
  },
  methods: {
    updateValue(navigationServiceId) {
      this.$root.$emit('updateBlockJSON', {
        name: this.initBlock.name,
        key: this.initBlock.key,
        parentKey: this.parentKey,
        value: {
          text: this.tempText.toLowerCase(),
          navigationServiceId
        }
      });
    },
    saveTempText(e) {
      const normalizedString = slugify(e);
      this.tempText = normalizedString + '';
      this.tempText = this.tempText.toLowerCase();
    },
    async syncNavigationService() {
      const path = this.initBlock.config.path === "/" ? "" : this.initBlock.config.path; // this is due to legacy path code where / is still saved as value but its wrong
      const finalTarget = path + this.tempText;
      const result = await this.$store.dispatch("navigationService/create", {key: this.$route.params.id, target: finalTarget.toLowerCase()});
      if (result.id) {
        this.updateValue(result.id);
      }
    }
  },
  mounted() {
    if (this.initBlock.value && this.initBlock.value.text) {
      this.tempText = this.initBlock.value.text;
    }
  }
}
</script>

<style lang="scss" scoped>
.small-margin {
  margin-bottom: 16px;
}
</style>